export class ProductForm extends window.BAO.CustomElement() {
  constructor() {
    super()
    this._isSubmitting = false
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this), true)
    this.listeners.add(window, 'load', this.openPushCart.bind(this))
  }  
  
  openPushCart () {
    if (sessionStorage.getItem('openPushCart') === 'true') {
      window.drawers.activeDrawerKey = 'cart'
      sessionStorage.removeItem('openPushCart')
    }
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    if (this._isSubmitting) {
      return false
    }

    await this.addToCart()
    return false
  }  
  
  async addToCart () {
    if (this._isSubmitting) {
      return
    }

    this._isSubmitting = true
    const submitButton = this.form.querySelector('button[type="submit"]')
    if (submitButton) {
      submitButton.disabled = true
    }

    try {
      return await window.BAO.Cart.addItemFromForm(this.form)
    } finally {
      this._isSubmitting = false
      if (submitButton) {
        submitButton.disabled = false
      }
    }
  }  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
